/**
 * PatientCard — DS Pattern clinique
 * PHI masqué (IPP ***) — zéro PHI en clair
 */

import { GlassCard } from '../../organisms';
import { Badge } from '../../atoms';
import styles from './PatientCard.module.css';

interface PatientCardProps {
  displayName: string;  /** Initiales ou nom déchiffré affiché par le parent */
  ipp?: string;         /** Toujours masqué — affiché '***' */
  service?: string;
  statut?: 'actif' | 'sorti' | 'urgence';
  onView?: () => void;
  className?: string;
}

const STATUT_VARIANT = { actif: 'success', sorti: 'neutral', urgence: 'danger' } as const;
const STATUT_LABEL   = { actif: 'Actif',   sorti: 'Sorti',   urgence: 'Urgence' };

export function PatientCard({ displayName, service, statut = 'actif', onView, className = '' }: PatientCardProps) {
  return (
    <GlassCard className={`${styles.card} ${className}`}>
      <div className={styles.top}>
        <div className={styles.avatar}>{displayName.charAt(0).toUpperCase()}</div>
        <div className={styles.info}>
          <div className={styles.name}>{displayName}</div>
          <div className={styles.ipp}>IPP : ***</div>
          {service && <div className={styles.service}><i className="bi bi-hospital me-1" />{service}</div>}
        </div>
        <Badge variant={STATUT_VARIANT[statut]}>{STATUT_LABEL[statut]}</Badge>
      </div>
      {onView && (
        <button className={styles.viewBtn} onClick={onView}>
          <i className="bi bi-folder2-open me-1" />Dossier
        </button>
      )}
    </GlassCard>
  );
}
